import type { EventSiteType } from '@crossbeam/itly';

import useIteratively from '@/composables/useIteratively';

import type { ApiTabValueType } from './types';

type ApiResourceType = 'webhook' | 'integration' | 'filter' | 'key';

type ApiControlsActionType =
  | 'create_clicked'
  | 'create_submitted'
  | 'secret_acknowledged'
  | 'test_clicked'
  | 'settings_saved';

type ApiControlsEventType = {
  eventSite: EventSiteType;
  type: ApiControlsActionType;
  resource: ApiResourceType;
  resourceId?: string | null;
  metadata?: Record<string, unknown>;
};

const RESOURCE_BY_TAB = {
  webhooks: 'webhook',
  integrations: 'integration',
  filters: 'filter',
  keys: 'key',
} as const satisfies Record<ApiTabValueType, ApiResourceType>;

export default function useApiControlsTracking() {
  const { iteratively } = useIteratively();

  function trackApiControlAction({
    eventSite,
    type,
    resource,
    resourceId,
    metadata,
  }: ApiControlsEventType) {
    iteratively.apiControlsAction({
      event_site: eventSite,
      type,
      resource,
      ...(resourceId && { resource_id: resourceId }),
      ...(metadata && { metadata }),
    });
  }

  function trackCreateClicked(tab: ApiTabValueType, eventSite: EventSiteType) {
    trackApiControlAction({
      eventSite,
      type: 'create_clicked',
      resource: RESOURCE_BY_TAB[tab],
    });
  }

  return { trackApiControlAction, trackCreateClicked };
}
